/*
 * BIZOUX クリスマス納期表示
 *   <xmas-deadline>      … クリスマス（12/24）お届けの注文締切日
 *   <xmas-delivery-date> … お届け予定日（Xmas納期パターンによる 12/24・1/10 固定 ＋ 通常計算）
 *
 * 年ごとに変わる値は BIZOUX_XMAS_CONFIG にまとめています。来年はここを書き換えてください。
 * 日付の判定はページキャッシュの影響を受けないよう、ブラウザ側で日本時間（UTC+9）基準で行います。
 *
 * テスト用：非公開テーマ（プレビュー）またはテーマエディタ内でのみ、URL に
 *   ?xmas_now=2026-11-02T10:30   … その日時（日本時間）として判定
 *   &xmas_pattern=3-2            … 商品の Xmas納期パターンをその値として判定
 * を付けて確認できます。
 */
(() => {
  const BIZOUX_XMAS_CONFIG = {
    // パターン表の日付（MM-DD）が属する年
    year: 2026,
    // 受注〆日のこの時刻（日本時間）から受付終了。画面には1分前（10:59）を表示
    cutoffTime: '11:00',
    // この月日（日本時間 0:00）以降は締切表示を出さない
    hideFromMonthDay: '12-25',
    // 固定期間に表示するお届け予定日
    christmasDate: '12/24',
    newYearDate: '1/10',

    // Xmas納期パターン（商品メタフィールド xmas.delivery_pattern の値）
    //   christmasFrom : 通常計算だと 12/24 以降になる日 … この日 0:00 〜 受注〆日 10:59 は「12/24」
    //   deadline      : Xmas受注〆日                    … 〆日 11:00 〜 newYearFrom の前日は「1/10」
    //   newYearFrom   : 通常計算だと 1/4 以降になる日   … この日 0:00 以降は通常計算
    // christmasFrom が deadline より後なら 12/24 固定の期間なし、
    // newYearFrom が deadline 以前なら 1/10 固定の期間なし（自動でそうなります）
    patterns: {
      '1-1': { christmasFrom: '10-29', deadline: '10-05', newYearFrom: '11-09' },
      '1-2': { christmasFrom: '10-22', deadline: '10-05', newYearFrom: '11-02' },
      '2-1': { christmasFrom: '10-29', deadline: '10-19', newYearFrom: '11-09' },
      '2-2': { christmasFrom: '10-22', deadline: '10-19', newYearFrom: '11-02' },
      '2-3': { christmasFrom: '10-15', deadline: '10-19', newYearFrom: '10-26' },
      '3-1': { christmasFrom: '11-05', deadline: '11-02', newYearFrom: '11-16' },
      '3-2': { christmasFrom: '10-29', deadline: '11-02', newYearFrom: '11-09' },
      '3-3': { christmasFrom: '10-22', deadline: '11-02', newYearFrom: '11-02' },
      '4-1': { christmasFrom: '11-05', deadline: '11-16', newYearFrom: '11-16' },
      '4-2': { christmasFrom: '10-29', deadline: '11-16', newYearFrom: '11-09' },
      '4-3': { christmasFrom: '10-22', deadline: '11-16', newYearFrom: '11-02' }
    },

    // Xmas納期パターンのタグ（例: Xmas2026納期4-1 → パターン 4-1）。メタフィールドが空のときに使う
    // タグの年が上の year と違う場合は無視する（前年のタグが残っていても動かない）
    patternTagPattern: /^Xmas(\d{4})納期(\d+-\d+)$/,

    // パターンがない商品用の締切タグ（例: Xmas20261005〆 → 2026/10/5 が締切日）
    deadlineTagPattern: /^Xmas(\d{4})(\d{2})(\d{2})〆$/
  };

  const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];
  const JST_OFFSET_MS = 9 * 60 * 60 * 1000;
  const DAY_MS = 24 * 60 * 60 * 1000;

  // 'YYYY-MM-DDTHH:MM' を日本時間として Date に変換（形式不正なら null）
  const parseJst = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
    const date = new Date(`${value}:00+09:00`);
    return isNaN(date.getTime()) ? null : date;
  };

  const isTestAllowed = () => {
    const shopify = window.Shopify || {};
    return Boolean(shopify.designMode || (shopify.theme && shopify.theme.role && shopify.theme.role !== 'main'));
  };

  const getTestParam = (name) => (isTestAllowed() ? new URLSearchParams(window.location.search).get(name) : null);

  const getNow = () => {
    const param = getTestParam('xmas_now');
    if (param) {
      const testNow = parseJst(param);
      if (testNow) return testNow;
      console.warn('[xmas] xmas_now の形式が不正です（例: 2026-11-02T10:30）:', param);
    }
    return new Date();
  };

  // 全角の数字・ハイフン類を半角にそろえる（手入力のタグの表記ゆれ対策）
  const normalize = (value) => String(value || '')
    .trim()
    .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))
    .replace(/[－‐‑–—−ー]/g, '-');

  // タグ「Xmas2026納期4-1」からパターン '4-1' を取り出す（年が違えば null）
  const patternFromTag = (tag) => {
    if (!tag) return null;
    const match = normalize(tag).match(BIZOUX_XMAS_CONFIG.patternTagPattern);
    if (!match) {
      console.warn('[xmas] Xmas納期パターンのタグの形式が不正です（例: Xmas2026納期4-1）:', tag);
      return null;
    }
    if (Number(match[1]) !== BIZOUX_XMAS_CONFIG.year) return null;
    return match[2];
  };

  // パターンの決定：テスト指定 ＞ メタフィールド ＞ タグ
  const getPattern = (value, tag) => {
    const key = normalize(getTestParam('xmas_pattern') || value || patternFromTag(tag));
    if (!key) return null;
    const pattern = BIZOUX_XMAS_CONFIG.patterns[key];
    if (!pattern) console.warn('[xmas] Xmas納期パターンが表にありません:', key);
    return pattern ? { key, ...pattern } : null;
  };

  // 日本時間の今日に days 日足した日付を 'M/D' で返す（通常計算）
  const addDaysJst = (now, days) => {
    const jst = new Date(now.getTime() + JST_OFFSET_MS);
    const result = new Date(Date.UTC(jst.getUTCFullYear(), jst.getUTCMonth(), jst.getUTCDate()) + days * DAY_MS);
    return `${result.getUTCMonth() + 1}/${result.getUTCDate()}`;
  };

  // 締切日（年・月・日）から表示状態を判定する
  //   'before' : 締切前 / 'after' : 締切後 / 'hidden' : 表示期間外 / 'invalid' : 締切日不明
  const getDeadlineState = (deadlineDay, now) => {
    if (!deadlineDay) return { state: 'invalid' };

    const { year, month, day } = deadlineDay;
    const ymd = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const deadline = parseJst(`${ymd}T${BIZOUX_XMAS_CONFIG.cutoffTime}`);
    const hideFrom = parseJst(`${year}-${BIZOUX_XMAS_CONFIG.hideFromMonthDay}T00:00`);
    if (!deadline || !hideFrom) return { state: 'invalid' };

    // 表示用の日付は日本時間で組み立てる（ブラウザのタイムゾーンに依存しない）
    const weekday = WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
    const [cutoffHour, cutoffMinute] = BIZOUX_XMAS_CONFIG.cutoffTime.split(':').map(Number);
    const lastMinute = cutoffHour * 60 + cutoffMinute - 1;
    const label = `${month}/${day}（${weekday}）${Math.floor(lastMinute / 60)}:${String(lastMinute % 60).padStart(2, '0')}`;

    let state = 'before';
    if (now >= hideFrom) state = 'hidden';
    else if (now >= deadline) state = 'after';

    return { state, label };
  };

  const deadlineFromPattern = (pattern) => {
    if (!pattern) return null;
    const [month, day] = pattern.deadline.split('-').map(Number);
    return { year: BIZOUX_XMAS_CONFIG.year, month, day };
  };

  const deadlineFromTag = (tag) => {
    const match = String(tag || '').match(BIZOUX_XMAS_CONFIG.deadlineTagPattern);
    return match ? { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) } : null;
  };

  // パターンと現在日時から固定のお届け予定日を返す（固定期間外なら null → 通常計算）
  const getPatternDeliveryDate = (pattern, now) => {
    if (!pattern) return null;
    const year = BIZOUX_XMAS_CONFIG.year;
    const christmasFrom = parseJst(`${year}-${pattern.christmasFrom}T00:00`);
    const deadline = parseJst(`${year}-${pattern.deadline}T${BIZOUX_XMAS_CONFIG.cutoffTime}`);
    const newYearFrom = parseJst(`${year}-${pattern.newYearFrom}T00:00`);

    if (now >= christmasFrom && now < deadline) return BIZOUX_XMAS_CONFIG.christmasDate;
    if (now >= deadline && now < newYearFrom) return BIZOUX_XMAS_CONFIG.newYearDate;
    return null;
  };

  // お届け予定日：パターンの固定日があればそれを、なければ通常計算を返す
  const getDeliveryDate = (leadDays, pattern, now) => getPatternDeliveryDate(pattern, now) || addDaysJst(now, leadDays);

  class XmasDeadline extends HTMLElement {
    connectedCallback() {
      const now = getNow();
      const pattern = getPattern(this.dataset.pattern, this.dataset.patternTag);
      const fromPattern = deadlineFromPattern(pattern);
      const fromTag = deadlineFromTag(this.dataset.tag);

      if (fromPattern && fromTag && (fromPattern.month !== fromTag.month || fromPattern.day !== fromTag.day)) {
        console.warn('[xmas] 締切タグと Xmas納期パターンの〆日が一致しません。パターンを優先します:', this.dataset.tag, pattern.key);
      }

      const result = getDeadlineState(fromPattern || fromTag, now);
      let html = '';

      if (result.state === 'before') {
        html = (this.dataset.textBefore || '').split('{deadline}').join(result.label);
      } else if (result.state === 'after' && this.dataset.afterMode !== 'hide') {
        html = this.dataset.textAfter || '';
      }

      this.innerHTML = html;
      this.hidden = html === '';

      if (isTestAllowed()) {
        console.info('[xmas] 締切表示', { now: now.toISOString(), pattern: pattern && pattern.key, tag: this.dataset.tag, state: result.state, deadline: result.label });
      }
    }
  }

  class XmasDeliveryDate extends HTMLElement {
    connectedCallback() {
      // HTML の読み込み途中だと子要素がまだないため、読み込み完了を待つ
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.render(), { once: true });
      } else {
        this.render();
      }
    }

    render() {
      const target = this.querySelector('.js-pr-biz-date');
      if (!target) return;

      const now = getNow();
      const leadDays = Number(this.dataset.leadDays) || 0;
      const pattern = this.dataset.patternEnable === 'true' ? getPattern(this.dataset.pattern, this.dataset.patternTag) : null;

      target.textContent = getDeliveryDate(leadDays, pattern, now);

      if (isTestAllowed()) {
        console.info('[xmas] お届け予定日', { now: now.toISOString(), leadDays, pattern: pattern && pattern.key, date: target.textContent });
      }
    }
  }

  window.BizouxXmas = { config: BIZOUX_XMAS_CONFIG, parseJst, getNow, getPattern, patternFromTag, getDeadlineState, deadlineFromPattern, deadlineFromTag, getPatternDeliveryDate, getDeliveryDate };

  if (!window.customElements.get('xmas-deadline')) {
    window.customElements.define('xmas-deadline', XmasDeadline);
  }
  if (!window.customElements.get('xmas-delivery-date')) {
    window.customElements.define('xmas-delivery-date', XmasDeliveryDate);
  }
})();
